import { Swiper, Pagination } from 'swiper';
import 'swiper/scss';

// Swiper.use(Navigation);
Swiper.use(Pagination);
class CarouselReviews extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
    this.$items = this.querySelector('.js-carousel-review__items');
    this.$pagination = this.querySelector('.js-carousel-review__pagination');
    if (this.$items) this.setupCarousel();
  }

  setupCarousel() {
    this.carousel = new Swiper(this.$items, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      // navigation: {
      //   nextEl: $nextBtn,
      //   prevEl: $prevBtn,
      // },
      pagination: {
        el: this.$pagination,
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 48,
        },
      },
    });
  }
}

export default function init() {
  customElements.define('carousel-reviews', CarouselReviews);
}
